import React from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';
import WifiOffOutlinedIcon from '@mui/icons-material/WifiOffOutlined';
import FemaleOutlinedIcon from '@mui/icons-material/FemaleOutlined';
import TransgenderOutlinedIcon from '@mui/icons-material/TransgenderOutlined';
import MaleOutlinedIcon from '@mui/icons-material/MaleOutlined';
import WifiFee from '@kamernet/icons/Wifi_fee.svg';
import {
  GenderEnum,
  InternetFacilityUsage,
} from '@kamernet/core/ApiClient/Kamernet';

const WifiStatusIconInternal = ({
  internetFacility,
}: {
  internetFacility: number;
}) => {
  let wifiIcon;
  switch (internetFacility) {
    case InternetFacilityUsage.Available:
    case InternetFacilityUsage.Unimportant:
      wifiIcon = <WifiOutlinedIcon />;
      break;
    case InternetFacilityUsage.NotAvailable:
      wifiIcon = <WifiOffOutlinedIcon />;
      break;
    case InternetFacilityUsage.AdditionalCharge:
      wifiIcon = <WifiFee />;
      break;
    default:
      wifiIcon = <WifiOutlinedIcon />;
  }
  return wifiIcon;
};
const RoommateNumberCountIconInternal = ({
  housematesNumberId,
}: {
  housematesNumberId: number;
}) => {
  let icon;
  switch (housematesNumberId) {
    case 0:
      icon = <PersonOffOutlinedIcon />;
      break;
    case 1:
      icon = <PersonOutlineOutlinedIcon />;
      break;
    case 2:
      icon = <PeopleAltOutlinedIcon />;
      break;
    case 3:
      icon = <GroupsOutlinedIcon />;
      break;
    default:
      icon = <PersonOutlineOutlinedIcon />;
  }
  return icon;
};
export const RoommateGenderIconInternal = ({
  housematesGenderId,
}: {
  housematesGenderId: number;
}) => {
  let icon;
  switch (housematesGenderId) {
    case GenderEnum.Male:
      icon = <MaleOutlinedIcon />;
      break;
    case GenderEnum.Female:
      icon = <FemaleOutlinedIcon />;
      break;
    case GenderEnum.Mixed:
      icon = <TransgenderOutlinedIcon />;
      break;
    default:
      icon = <TransgenderOutlinedIcon />;
  }
  return icon;
};

export const WifiStatusIcon = React.memo(WifiStatusIconInternal);
export const RoommateNumberCountIcon = React.memo(
  RoommateNumberCountIconInternal,
);
export const RoommateGenderIcon = React.memo(RoommateGenderIconInternal);
